import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { formatDualDate } from '@/shared/lib/dates';
import { Async } from '@/shared/ui/Async';
import { Badge } from '@/shared/ui/Badge';
import { useUiStore } from '@/stores/ui.store';

import { useMarkRead, useMyNotifications } from '../hooks/use-notifications';

/** The recipient's notification history (the PDPL audit log, user-facing). */
export function NotificationsRoute(): JSX.Element {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const locale = useUiStore((s) => s.locale);
  const query = useMyNotifications();
  const markRead = useMarkRead();

  return (
    <main className="page stack">
      <h1>{t('notifications.title')}</h1>
      <Async query={query} isEmpty={(l) => l.length === 0} emptyMessage={t('notifications.empty')}>
        {(list) => (
          <div className="stack">
            {list.map((n) => (
              <button
                key={n.id}
                type="button"
                className="card card--interactive stack"
                onClick={() => {
                  if (!n.readAt) markRead.mutate(n.id);
                  if (n.relatedRequestId) navigate(`/requests/${n.relatedRequestId}`);
                }}
              >
                <div className="row row--between">
                  <strong>{n.title}</strong>
                  {!n.readAt ? (
                    <Badge label={t('notifications.new')} color="var(--color-primary)" />
                  ) : null}
                </div>
                <span>{n.body}</span>
                <span className="muted">{formatDualDate(new Date(n.createdAt), locale)}</span>
              </button>
            ))}
          </div>
        )}
      </Async>
    </main>
  );
}
